import IMask from "imask";

function phoneInputs() {
  const phoneInputs = document.querySelectorAll("input[type='tel']");

  if (phoneInputs.length > 0) {
    phoneInputs.forEach((input) => {
      let mask;
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

      if (isIOS && window.innerWidth <= 768) {
        // Инициализация масок с условием для начала с 8 и с +7
        mask = IMask(input, {
          mask: [
            {
              mask: "0 (000) 000-00-00",
              startsWith: "8", // Маска для номеров, начинающихся с 8
            },
            {
              mask: "+{7} (000) 000-00-00", // Маска для номеров с кодом страны +7
            },
          ],
          dispatch: (appended, dynamicMasked) => {
            // Считываем текущее значение и добавляем введенную цифру
            const number = (dynamicMasked.value + appended).replace(/\D/g, "");

            // Ищем маску, подходящую под номер
            return dynamicMasked.compiledMasks.find((m) => {
              return !m.startsWith ? true : number.indexOf(m.startsWith) === 0;
            });
          },
        });
      } else {
        mask = IMask(input, {
          mask: "+{7} (000) 000-00-00",
          lazy: input.placeholder === "" ? false : true,
        });
      }

      const correctPhone = (value) => {
        // Убираем все нецифровые символы
        let cleaned = (value || "").replace(/\D/g, "");

        // Проверка на наличие '8' в начале и только в этом случае меняем на '7'
        if (cleaned.startsWith("8") && cleaned.length > 1) {
          cleaned = "7" + cleaned; // Заменяем 8 на 7 только если номер имеет более одной цифры
        }

        if (cleaned.startsWith("779")) cleaned = cleaned.slice(1);
        if (cleaned.startsWith("789")) cleaned = cleaned.slice(2);

        return cleaned;
      };

      // Обработчик вставки
      input.addEventListener("paste", (e) => {
        const pasted = e.clipboardData?.getData("text") || "";
        mask.unmaskedValue = correctPhone(pasted); // Применяем сразу без таймаута
      });

      // Обработчик для ввода текста вручную
      input.addEventListener("input", () => {
        const normalized = correctPhone(input.value); // Нормализуем после изменения значения
        if (normalized !== mask.unmaskedValue) {
          mask.unmaskedValue = normalized; // Применяем нормализованное значение
        }
      });
    });
  }
}

function fileInputs() {
  const inputFiles = document.querySelectorAll(
    'input[type="file"].custom-file'
  );

  if (inputFiles.length > 0) {
    // Нормализация токенов: ".doc" | ".docx" | ".pdf" | ".pptx" | "image/*" | "application/pdf"
    const parseTokens = (s) =>
      (s || "")
        .split(",")
        .map((t) => t.trim().toLowerCase())
        .filter(Boolean)
        .map((t) => (t.startsWith(".") || t.includes("/") ? t : `.${t}`)); // если забыли точку — добавим

    // Сравнение файла с правилом
    const matches = (file, token) => {
      const name = (file.name || "").toLowerCase();
      const type = (file.type || "").toLowerCase();
      if (token.startsWith(".")) return name.endsWith(token); // по расширению
      if (token.endsWith("/*")) return type.startsWith(token.slice(0, -1)); // по MIME-группе
      return type === token; // точный MIME
    };

    inputFiles.forEach((fileInput) => {
      // 1) Берём ИСКЛЮЧИТЕЛЬНО из data-accept
      const dataAccept =
        fileInput.getAttribute("data-accept") || fileInput.dataset.accept || "";
      const allowed = parseTokens(dataAccept);

      // 2) Ставим accept назад только ради UX (не для безопасности)
      if (allowed.length) fileInput.setAttribute("accept", allowed.join(","));

      // обёртка/лейбл/текст
      const label = document.createElement("label");
      label.className = "input-file";
      const buttonDiv = document.createElement("div");
      buttonDiv.className = "input-file__button";
      const textDiv = document.createElement("div");
      textDiv.className = "input-file__text";
      const span = document.createElement("span");
      const placeholderText =
        fileInput.getAttribute("placeholder") || "Загрузите файл";
      span.textContent = placeholderText;
      textDiv.appendChild(span);
      label.appendChild(buttonDiv);
      buttonDiv.appendChild(textDiv);

      if (allowed.length) {
        const typesDiv = document.createElement("div");
        typesDiv.className = "input-file__types";
        typesDiv.textContent =
          "Прикрепите файл в формате " + allowed.join(", ").toUpperCase();
        label.appendChild(typesDiv);
      }

      const parent = fileInput.parentNode;
      parent.replaceChild(label, fileInput);
      label.appendChild(fileInput);

      // 3) Жёсткая проверка
      fileInput.addEventListener("change", function () {
        const files = Array.from(this.files || []);
        if (!files.length) {
          span.textContent = placeholderText;
          return;
        }

        // Если список пуст (ошибка в разметке) — запрещаем всё
        if (!allowed.length) {
          alert("Неверная конфигурация поля: data-accept не задан.");
          this.value = "";
          span.textContent = placeholderText;
          return;
        }

        const bad = files.filter((f) => !allowed.some((t) => matches(f, t)));
        if (bad.length) {
          alert(
            `Недопустимый формат: ${bad.map((f) => f.name).join(", ")}\n` +
              `Допустимые: ${allowed.join(", ")}`
          );
          this.value = "";
          span.textContent = placeholderText;
          return;
        }

        span.textContent =
          files.length === 1 ? files[0].name : `${files.length} файла(ов)`;
      });
    });
  }
}

export function initInputs() {
  phoneInputs();
  fileInputs();
}
